import React, { useState, useEffect } from 'react';
import Button from 'src/components/button/Button';
import { CompanySetupModal } from './CompanySetupModal';
import { CompanyAPIService } from 'src/services/company.service';
import { useGetIdentity } from 'src/hooks';
import { TGetCompanyResponse } from 'src/services/apiEndpoint.types.ts';
import { useNavigate } from 'react-router-dom';

const HeroSection: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [checkingCompany, setCheckingCompany] = useState(false);
  const [company, setCompany] = useState(null);
  const { getIdentities } = useGetIdentity();
  const { authenticatedId, authenticatedEmail } = getIdentities();
  const companyServiceRef = React.useRef<CompanyAPIService | null>(null);
  const navigate = useNavigate();

  // Initialize companyService once
  useEffect(() => {
    companyServiceRef.current = new CompanyAPIService();
  }, []);

  const handleOpenModal = async () => {
    try {
      setCheckingCompany(true);
      
      // Always fetch fresh company data when clicked
      const response = await companyServiceRef.current.getCompany<TGetCompanyResponse>({
        id: authenticatedId
      });

      if (response.status && response.data?.company) {
        setCompany(response.data.company);
        // If terms are accepted, navigate to score page
        if (response.data.company.termsAndConditions) {
          // Navigate to score page would go here
          navigate('/score');
          return;
        }
      }
      
      // If we get here, either no company exists or terms not accepted
      setShowModal(true);
    } catch (error) {
      console.error('Error checking company:', error);
      setShowModal(true);
    } finally {
      setCheckingCompany(false);
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-content">
        <h1>Your funding readiness.</h1>
        <h1 className="gradient-text">Quantified</h1>
        <Button 
          variant="primary"
          onClick={handleOpenModal}
          className="cta-button"
          disabled={checkingCompany}
        >
          {checkingCompany ? (
            <div className="spinner-border spinner-border-sm text-light" role="status">
              <span className="sr-only"></span>
            </div>
          ) : (
            'GET YOUR STARTUP SCORE'
          )}
        </Button>
      </div>

      <CompanySetupModal 
        show={showModal}
        onHide={() => setShowModal(false)}
        authenticatedId={authenticatedId}
        authenticatedEmail={authenticatedEmail}
        existingCompany={company}
      /> 
  
    </section>
  );
};

export default HeroSection;
